<script setup>
// ContactDetailOverview.vue — tab "Visao geral" da tela de detalhe.
// Contem o ContactsForm existente (2 colunas) + Save sticky no rodape.
//
// Logica de salvar e identica a do antigo ContactDetails.vue (mantida
// pra preservar compatibilidade com store/contacts/update).
import { computed, ref, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import Button from 'dashboard/components-next/button/Button.vue';
import ContactsForm from 'dashboard/components-next/Contacts/ContactsForm/ContactsForm.vue';

const props = defineProps({
  selectedContact: { type: Object, required: true },
});

const { t } = useI18n();
const store = useStore();

const contactsFormRef = ref(null);

const uiFlags = useMapGetter('contacts/getUIFlags');
const isUpdating = computed(() => uiFlags.value.isUpdating);

const isFormInvalid = computed(() => contactsFormRef.value?.isFormInvalid);

const contactData = ref({});

const initState = () => {
  if (!props.selectedContact) return;
  contactData.value = { ...props.selectedContact };
};

onMounted(initState);

watch(
  () => props.selectedContact?.id,
  () => initState()
);

const handleFormUpdate = updatedData => {
  Object.assign(contactData.value, updatedData);
};

const updateContact = async () => {
  try {
    const { customAttributes, ...basicContactData } = contactData.value;
    await store.dispatch('contacts/update', basicContactData);
    await store.dispatch(
      'contacts/fetchContactableInbox',
      props.selectedContact.id
    );
    useAlert(t('CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.SUCCESS_MESSAGE'));
  } catch (error) {
    useAlert(t('CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.ERROR_MESSAGE'));
  }
};
</script>

<template>
  <div class="flex flex-col flex-1 min-h-0">
    <div class="flex-1 overflow-y-auto px-6 py-6">
      <div class="max-w-3xl mx-auto">
        <ContactsForm
          ref="contactsFormRef"
          :contact-data="contactData"
          is-details-view
          @update="handleFormUpdate"
        />
      </div>
    </div>

    <!-- Save sticky no rodape -->
    <div
      class="shrink-0 flex items-center justify-end gap-3 px-6 py-3 border-t border-n-weak bg-n-background"
    >
      <span v-if="isFormInvalid" class="text-xs text-n-ruby-11">
        {{ t('CONTACT_VIEW.OVERVIEW.INVALID_HINT') }}
      </span>
      <Button
        :label="t('CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.UPDATE_BUTTON')"
        size="sm"
        :is-loading="isUpdating"
        :disabled="isUpdating || isFormInvalid"
        @click="updateContact"
      />
    </div>
  </div>
</template>
